// import { poof, stopConfetti } from './confetti.js';
require ('./newConfetti.js');

function isFriend() {
	let friend = false;
	if (!!localStorage.getItem('isFriend') === true) {
		friend = true;
	}
	return friend;
}

function isFriendSaleActive() {
	return !!customData.isFriendSaleActive;
}

function rememberFriend() {
	localStorage.setItem('isFriend', true);
}

function forgetFriend() {
	localStorage.removeItem('isFriend');
}

function isNewFriend() {

	if (isFriend()) {
		return false;
	}
	if (isFriendPage()) {
		return true;
	}
	return false;
}

function isFriendPage() {
	let key = '/vriendenvancultura24-25';
	if (window.location.toString().indexOf(key) > 0) {
		return true;
	}
	return false;
}

function showFriendTicketButtons() {
	if (document.body.contains(document.querySelector('.btn--friend-sale'))) {
		document.querySelectorAll('.btn--friend-sale').forEach(function (el, i) {
			el.classList.remove('hide');
		});
	}
}

function hideRegularTicketButtons() {
	if (document.body.contains(document.querySelector('.btn--has-friend-link'))) {
		document.querySelectorAll('.btn--has-friend-link').forEach(function (el, i) {
			el.classList.add('hide');
		});
	}
}

export default function showTicketButtons() {
	hideRegularTicketButtons();
	showFriendTicketButtons();
}

function sayHi() {
	console.log('Hi, friend!');
}

// function showConfetti() {
// 	poof();
// 	setTimeout(stopConfetti, 4000);
// }

function newConfetti() {
	var count = 200;
	var defaults = {
		origin: { y: 0.7 },
	};
	function fire(particleRatio, opts) {
		confetti({
		...defaults,
		...opts,
		particleCount: Math.floor(count * particleRatio),
		});
	}

	fire(0.25, {
		spread: 26,
		startVelocity: 55,
	});
	fire(0.2, {
		spread: 60,
	});
	fire(0.35, {
		spread: 100,
		decay: 0.91,
		scalar: 0.8,
	});
	fire(0.1, {
		spread: 120,
		startVelocity: 25,
		decay: 0.92,
		scalar: 1.2,
	});
	fire(0.1, {
		spread: 120,
		startVelocity: 45,
	});
}

// actions triggered the first time the correct friend page is visited
function doFriendFirstTimeActions() {
	sayHi();
	rememberFriend();
	showTicketButtons();
}


// actions always triggered, after a friend has been acknowledged
function doFriendAlwaysActions() {
	if (isFriendPage()) {
		newConfetti();
		newConfetti();
		newConfetti();
	}
	showTicketButtons();
	sayHi();
}

function vriendenverkoop() {
	if ( isFriendSaleActive() ) {
		if (isNewFriend()) {
			doFriendFirstTimeActions();
		}
		if (isFriend()) {
			doFriendAlwaysActions();
		}
	}
}

vriendenverkoop();



